// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"title_titleContainer__cbhJv","title":"title_title__0HwpZ","more":"title_more__t_Xl5"};